import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Customer } from "../../components/Customers/types/customer";
import { SampleCustomers } from "../../components/Customers/constants/customerConstants";

export interface CustomerState {
  customerList: Customer[];
  customerDetail?: Customer;
}

export const initialCustomerState: CustomerState = {
  customerList: SampleCustomers
};

export const customerSlice = createSlice({
  name: "customers",
  initialState: initialCustomerState,
  reducers: {
    setCustomerList: (state, action: PayloadAction<Customer[]>) => {
      state.customerList = action.payload;
    },

    resetCustomerList: (state) => {
      state.customerList = initialCustomerState.customerList;
    },

    addCustomerList: (state, action: PayloadAction<Customer[]>) => {
      state.customerList = [...state.customerList, ...action.payload];
    },

    setCustomerDetail: (state, action: PayloadAction<Customer>) => {
      state.customerDetail = action.payload;
    },

    resetCustomerDetail: (state) => {
      state.customerDetail = initialCustomerState.customerDetail;
    },

    addCustomer: (state, action: PayloadAction<Customer>) => {
      state.customerList = [...state.customerList, action.payload];
    },

    updateCustomer: (state, action: PayloadAction<Customer>) => {
      const index = state.customerList.findIndex(
        (c) => c.id === action.payload.id
      );
      if (index !== -1) {
        state.customerList[index] = action.payload;
      }
    },

    deleteCustomer: (state, action: PayloadAction<string>) => {
      state.customerList = state.customerList.filter(
        (c) => c.id !== action.payload
      );
    }
  }
});

export const {
  setCustomerList,
  setCustomerDetail,
  resetCustomerList,
  addCustomerList,
  resetCustomerDetail,
  addCustomer,
  updateCustomer,
  deleteCustomer
} = customerSlice.actions;

export default customerSlice.reducer;
